import { useEffect } from 'react';
import { useRouter } from 'next/router';
import CookieUtils from 'utils/cookies';
import intersection from 'lodash/intersection';
import Auth from 'services/auth';
import { useNotification } from 'modules/shared/hooks';
import { AUTHENTICATION_ACTIONS, telemetry } from 'utils/telemetry';
import routes from 'routes';

/**
 * Replacement for Snorlax's functionality of rerouting a user to a log out if
 * they don't have the required scopes.
 */

export const usePageAccess = (allowedScopes: string[] = []) => {
  const router = useRouter();
  const notify = useNotification();
  const usersScopes = CookieUtils.getUserScopes() || [];

  const hasAccessToThisPage = usersScopes.length > 0 && intersection(usersScopes, allowedScopes).length > 0;
  const shouldBeLoggedOut = Auth.shouldLogoutBasedOnScopes(usersScopes);

  useEffect(() => {
    if (shouldBeLoggedOut) {
      telemetry.addAction(AUTHENTICATION_ACTIONS.PAGE_ACCESS_REDIRECT_TO_LOGOUT);
      router.replace(routes.Logout.as);
    } else {
      if (!hasAccessToThisPage) {
        notify({
          status: 'error',
          description: `You do not have access to ${router.asPath}. Please contact your administrator.`,
        });
        router.replace('/admin');
      }
    }
  }, []);

  return null;
};
